@use '@fukuri-admins/ui/layout' as *;

.iconButton {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: borderRadius('lg');
  border: none;
  cursor: pointer;
  aspect-ratio: 1;
  transition: all 0.2s ease-in-out;

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }

  svg {
    color: currentColor;
  }

  &:disabled {
    cursor: not-allowed;
    // .svgIcon が直接 color: text('High') を持つため継承では届かない。
    // ここで svg に対して color: inherit を指定することで、
    // 各バリアントの :disabled color（例: text('High50')）が SVG に反映される。
    svg { color: inherit; }
  }
}

@mixin overlay-bg($overlay, $base) {
  background: linear-gradient(
    0deg,
    background($overlay) 0%,
    background($overlay) 100%
  ), background($base);
}

.primary {
  color: text('White');
  background-color: background('Gray_Darken');
  &:hover:not(:disabled) { @include overlay-bg('Overlay_Wh_10', 'Gray_Darken'); }
  &:active:not(:disabled) { @include overlay-bg('Overlay_Wh_40', 'Gray_Darken'); }
  &:disabled { @include overlay-bg('Overlay_Wh_50', 'Gray_Darken'); }
}

.secondary {
  color: text('High');
  background-color: background('Secondary');

  &:hover:not(:disabled) { @include overlay-bg('Overlay_Wh_20', 'Secondary'); }
  &:active:not(:disabled) {
    color: text('High60');
    @include overlay-bg('Overlay_Wh_40', 'Secondary');
  }
  &:disabled {
    color: text('High50');
    @include overlay-bg('Overlay_Wh_50', 'Secondary');
  }
}

.destructive {
  color: text('White');
  background-color: background('Red_Darken');

  &:hover:not(:disabled) { @include overlay-bg('Overlay_Wh_10', 'Red_Darken'); }
  &:active:not(:disabled) { @include overlay-bg('Overlay_Wh_40', 'Red_Darken'); }
  &:disabled { @include overlay-bg('Overlay_Wh_50', 'Red_Darken'); }
}

.outline {
  color: text('High');
  background-color: background('Primary');
  border: 1px solid border('Quaternary');

  &:hover:not(:disabled) {
    background-color: background('Secondary');
  }

  &:active:not(:disabled) {
    color: text('High60');
    background-color: background('Primary');
  }

  &:disabled {
    color: text('High50');
  }
}

.ghost {
  color: text('High');
  background-color: transparent;

  &:hover:not(:disabled) {
    background-color: background('Overlay_Bl_5');
  }

  &:active:not(:disabled) {
    color: text('High60');
    background-color: transparent;
  }

  &:disabled {
    color: text('High50');
  }
}

.ghostDestructive {
  color: text('Red');
  background-color: transparent;

  &:hover:not(:disabled) {
    background-color: background('Overlay_Bl_5');
  }

  &:active:not(:disabled) {
    color: text('Red60');
    background-color: transparent;
  }

  &:disabled {
    color: text('Red50');
  }
}

.xs {
  width: 24px;
  height: 24px;
  padding: spacing('4');
}

.sm {
  width: 32px;
  height: 32px;
  padding: spacing('8');
}

.md {
  width: 40px;
  height: 40px;
  padding: spacing('12');
}

.lg {
  width: 48px;
  height: 48px;
  padding: spacing('16');
}
